import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../state'
import * as shared from '../shared'

/** Modal for editing cluster functional usage */
@ngCore.Component({
  imports: [
    ds.layout.widget.Component,
    ds.overlay.centered.Component,
    ds.button.Component,
    ds.notice.Component,
    shared.functionalizations.Component,
  ],
  selector: 'atn-space-cluster-functional-usage-modal',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.space.full.clusters.plugins.functionalUsage.Plugin} */
  public readonly functionalUsagePlugin = ngCore
    .inject(state.space.full.clusters.Collection)
    .plugins.lookup(state.space.full.clusters.plugins.functionalUsage.Plugin)
    .get()

  /** @see {@link state.space.full.warnings.plugin.Plugin} */
  public readonly clusterWarningsPlugin = ngCore
    .inject(state.space.full.clusters.Collection)
    .plugins.lookup(state.space.full.warnings.plugin.Plugin)
    .get()

  /** @see {@link ents.core.display.Style} */
  public readonly DisplayStyle = ents.core.display.Style

  /** @see {@link ents.extra.space.Warning.Code} */
  public readonly WarningCode = ents.extra.space.Warning.Code

  /** Whether user can save: true if functionalizations are fully coded (sum to 100%) */
  public readonly canSaveSg = ngCore.computed(
    (
      functionalizations = this.functionalUsagePlugin.selectors.editingFunctionalUsage.asSignal(),
    ) => {
      if (!functionalizations) {
        return false
      }
      return ents.extra.space.Functionalization.isFullyCoded(functionalizations)
    },
  )

  /** Handle cancel/close button */
  public cancelClickHandler(): void {
    this.functionalUsagePlugin.actions.discard
      .from('Space.ClusterDetails.FunctionalUsageModal.Cancel.Clicked')
      .dispatch()
  }

  /** Handle save button */
  public saveClickHandler(): void {
    this.functionalUsagePlugin.actions.applyUpdates
      .from('Space.ClusterDetails.FunctionalUsageModal.Save.Clicked')
      .dispatch()
  }

  /** Handle functionalization slider change */
  public updateFunctionalization(
    functionalization: ents.extra.space.Functionalization,
  ): void {
    this.functionalUsagePlugin.actions.updateFunctionalization
      .from(
        'Space.ClusterDetails.FunctionalUsageModal.FunctionalizationChanged',
      )
      .dispatch(functionalization)
  }
}
